// Deliberately import-free (mirrors the backend's own ConferenceSaveLevel.ts): conferenceRest.ts
// pulls in the store, so store type modules can only reference this type via a leaf module like this.
//
// What of the recording to keep: a ladder, not independent flags — each level includes everything
// below it (video ⊃ audio ⊃ transcription ⊃ nothing). See backend EConferenceSaveLevel (LNG-1710).
export type TConferenceSaveLevel = 'video' | 'audio' | 'transcription' | 'nothing';

// The ladder itself, loosest first — same order as the backend's own CONFERENCE_SAVE_LEVELS, which
// /process and deleteMedia compare with indexOf. Keep the two in sync: a higher index keeps less.
export const CONFERENCE_SAVE_LEVELS: TConferenceSaveLevel[] = ['video', 'audio', 'transcription', 'nothing'];

// True when `level` keeps strictly less than `other`.
export const isStricterSaveLevel = (level: TConferenceSaveLevel, other: TConferenceSaveLevel): boolean =>
	CONFERENCE_SAVE_LEVELS.indexOf(level) > CONFERENCE_SAVE_LEVELS.indexOf(other);
